import { ChangeDetectionStrategy, Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { AccountService } from '../../account/shared/account.service';
import { Activity } from '../shared/activity';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-activity-timeline',
  templateUrl: './activity-timeline.component.html',
  styleUrls: ['./activity-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ActivityTimelineComponent implements OnInit, AfterViewInit {

  @ViewChild(CdkVirtualScrollViewport, { static: true }) virtualScroll?: CdkVirtualScrollViewport;

  titleText = 'タイムライン';
  activities: Activity[] = [];
  continuationToken: string | null = null;

  constructor(
    private _accountService: AccountService,
  ) { }

  private async retrieveAllActivities() {
    const res = await this._accountService.retrieveAllActivities(this.continuationToken).toPromise();
    this.activities = [...this.activities, ...res.entities.map(entity => new Activity(entity))];
    this.continuationToken = res.token;
  }

  async ngOnInit() {
    await this.retrieveAllActivities();
  }

  ngAfterViewInit() {
    if (this.virtualScroll) {
      this.virtualScroll.renderedRangeStream.subscribe(async range => {
        if (this.continuationToken && this.activities.length === range.end) {
          await this.retrieveAllActivities();
        }
      });
    }
  }
}
